module.exports = __webpack_public_path__ + "static/media/20210401_224532_392_IMG_0007.cfd126b5.jpg";